import { useEffect } from 'react';
import { initializeFacebookTracking } from '@/hooks/useFacebookTracking';

/**
 * Component that initializes first-party Facebook tracking on app load.
 * This captures fbclid from URL and generates a first-party fbp immediately,
 * bypassing third-party cookie blockers and ad blockers.
 */
const FacebookTrackingInit = () => {
  useEffect(() => {
    // Initialize tracking immediately on mount
    const trackingData = initializeFacebookTracking();
    console.log('First-party Facebook tracking initialized:', trackingData);
  }, []);

  return null;
};

export default FacebookTrackingInit;
